import { FC } from 'react';
import { UploadInput } from 'components/Inputs/UploadInput';
import { ReactComponent as StarIcon } from 'assets/star_required_icon.svg';
import { IImageUploaderProps } from './types';
import styles from './imageUploader.module.scss';

export const ImageUploader: FC<IImageUploaderProps> = (props) => {
  const { title = 'cover', width, height, required, classNameProp } = props;
  return (
    <div className={`${styles.imageUploader} ${classNameProp}`} style={{ width, height }}>
      <div className={styles.header}>
        <h6 className={`${styles.title}`}>{title}</h6>
        {required && <StarIcon />}
      </div>
      <UploadInput {...props} isRemoveMargin />
    </div>
  );
};
